import { render, staticRenderFns } from "./draftProduct.vue?vue&type=template&id=fe2f35be&scoped=true"
import script from "./draftProduct.vue?vue&type=script&lang=js"
export * from "./draftProduct.vue?vue&type=script&lang=js"
import style0 from "./draftProduct.vue?vue&type=style&index=0&id=fe2f35be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2f35be",
  null
  
)

export default component.exports